
	import { Component, Prop } from 'vue-property-decorator';
	import { Route } from 'vue-router';
	import { BaseView } from '@shared/views/BaseView';
	import { Artist, SubjectAggregate } from '@shared/models';
	import ArtistItem from '../artists/ArtistItem.vue';

	@Component({
		components: {
			ArtistItem,
		},
	})
	export default class ArtistItemList extends BaseView {

		@Prop({ default: 'Artists' })
		public title: string;

		@Prop({ default: 80 })
		public iconSize: number;

		@Prop({ default: 10 })
		public nameSize: number;

		@Prop()
		public viewRoute: Route;

		@Prop({ default: () => new Array<SubjectAggregate<Artist>>() })
		public list: Array<SubjectAggregate<Artist>>;

	}

